import { useEffect, useState } from "react";
import {
  PaymentMethodAnimationConfiguration as AnimConfig,
  GlobalConfiguration,
} from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText";
import Validation from "../../../utils/validation";
import AmountToWords from "../../_utils/AmountToWords";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import PaymentMethodSelector from "../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import "./index.css";
import Loader from "../../Loader/Index";
import CommonLayout from "../../_utils/CommonLayout";

const InternalTxnAmount = (props) => {
  const COPY_KEYS = {
    AMOUNT: "TRANSFER_AMOUNT",
  };

  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };

  const handleDivBtn = (value) => {
    props?.setSelectedRadioValue(value);
    if (value === "destinationAcc") {
      props?.setTxnPayLoad((prev) => ({
        ...prev,
        amount: Math.abs(props?.txnPayLoad.destinationAccountBalance),
        amountInWords:
          Math.abs(props?.txnPayLoad.destinationAccountBalance) >
            GlobalConfiguration.lengthCheckZero &&
          Math.abs(props?.txnPayLoad.destinationAccountBalance) <=
            GlobalConfiguration.lengthCheckOne
            ? Math.abs(props?.txnPayLoad.destinationAccountBalance).replace(
                "rupees",
                "rupee",
              )
            : Math.abs(props?.txnPayLoad.destinationAccountBalance),
      }));
    } else if (value === "sourceAcc") {
      props?.setTxnPayLoad((prev) => ({
        ...prev,
        amount: Math.abs(props?.txnPayLoad.ownerBankBalance),
        amountInWords:
          Math.abs(props?.txnPayLoad.ownerBankBalance) >
            GlobalConfiguration.lengthCheckZero &&
          Math.abs(props?.txnPayLoad.ownerBankBalance) <=
            GlobalConfiguration.lengthCheckOne
            ? Math.abs(props?.txnPayLoad.ownerBankBalance).replace(
                "rupees",
                "rupee",
              )
            : Math.abs(props?.txnPayLoad.ownerBankBalance),
      }));
    }
  };

  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      props.setTxnPayLoad((prev) => ({
        ...prev,
        amount: "",
        amountInWords: "",
      }));
      props.setShowRupeeSymbol(false);
      return;
    }

    if (trimmedValue[0] === "0") return;

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");
    const enteredAmount = parseFloat(
      numericValue || GlobalConfiguration.lengthCheckZero,
    );

    if (
      enteredAmount ===
      parseFloat(Math.abs(props?.txnPayLoad.destinationAccountBalance))
    ) {
      props?.setSelectedRadioValue("destinationAcc");
    } else if (
      enteredAmount === parseFloat(Math.abs(props?.txnPayLoad.ownerBankBalance))
    ) {
      props?.setSelectedRadioValue("sourceAcc");
    } else {
      props?.setSelectedRadioValue("customname");
    }

    if (
      name === "amount" &&
      (allowedValue(numericValue) || !numericValue.length)
    ) {
      const amountNumber = parseFloat(numericValue);
      const amountWords =
        numericValue.trim() === "" ? "" : AmountToWords(amountNumber);

      const adjustedAmountWords =
        amountNumber > GlobalConfiguration?.lengthCheckZero &&
        amountNumber <= GlobalConfiguration?.lengthCheckOne
          ? amountWords.replace("rupees", "rupee")
          : amountWords;

      props?.setTxnPayLoad((prev) => ({
        ...prev,
        amount: numericValue,
        amountInWords: adjustedAmountWords,
      }));

      props?.setShowRupeeSymbol(numericValue.trim() !== "");
      props?.setAmountInWords(adjustedAmountWords);
    }
  };
  useEffect(() => {
    if (
      Number(props?.txnPayLoad?.amount) !==
      Number(props?.txnPayLoad?.ownerBankBalance)
    ) {
      props.setSelectedRadioValue("customname");
    }
    props.setNextButtonEnabled(true);
  }, []);

  return (
    <>
      {props?.txnLoading ? (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-max  bg-PopUp-BackDrop opacity-dark-opacity">
            <div>
              <Loader type={"bulk_upload"} />
              <p className=" font-semibold text-font-lg text-text-primary">
                Validating the data
              </p>
            </div>
          </div>
        </>
      ) : (
        <div
          className={`relative z-z-index-content w-width-full max-w-screen-lg px-padding-md lg:px-padding-base snap-start justify-center  Qmd:mt-margin-base ${props?.reminder_remark !== null && props?.flow === "ReminderFlow" ? "lg:pt-padding-md pt-padding-md" : `${props?.refactor ? "mt-margin-md" : ""} py-padding-md`}`}
        >
          <CommonLayout>
            <Amount
              title={TEXT?.TRANSFER_AMOUNT}
              amount={props?.txnPayLoad?.amount}
              amountInWords={props?.amountInWords}
              copyData={props?.copyData}
              onAmountChange={(val) =>
                handleAmountChange({ name: "amount", value: val })
              }
              onPasteApplied={() => {
                const { copyData } = props;

                if (
                  copyData?.title === COPY_KEYS.AMOUNT &&
                  copyData?.data_type === "numeric"
                ) {
                  const pastedValue = copyData?.value?.toString();

                  handleAmountChange({
                    name: "amount",
                    value: pastedValue,
                  });
                }

                props?.setCopyData({ title: "", data_type: "", value: "" });
              }}
              sourceAmount={
                Number(props.txnPayLoad?.ownerBankBalance) >
                GlobalConfiguration.lengthCheckZero
                  ? Math.abs(props.txnPayLoad?.ownerBankBalance)
                  : undefined
              }
              destinationAmount={
                Number(props.txnPayLoad?.destinationAccountBalance) <
                GlobalConfiguration.lengthCheckZero
                  ? Math.abs(props.txnPayLoad?.destinationAccountBalance)
                  : undefined
              }
              isPreview={false}
              customAmountRequired={
                (Number(props.txnPayLoad?.ownerBankBalance) >
                  GlobalConfiguration.lengthCheckZero &&
                  Number(props.txnPayLoad?.destinationAccountBalance) >
                    GlobalConfiguration.lengthCheckZero) ||
                (Number(props.txnPayLoad?.ownerBankBalance) <=
                  GlobalConfiguration.lengthCheckZero &&
                  Number(props.txnPayLoad?.destinationAccountBalance) <=
                    GlobalConfiguration.lengthCheckZero) ||
                (Number(props.txnPayLoad?.ownerBankBalance) >
                  GlobalConfiguration.lengthCheckZero &&
                  (Number(props.txnPayLoad?.destinationAccountBalance) <=
                    GlobalConfiguration.lengthCheckZero ||
                    isNaN(props.txnPayLoad?.destinationAccountBalance)))
              }
              handleDivBtn={(val) => handleDivBtn(val)}
              selectedRadioValue={props?.selectedRadioValue}
              flow="internlaTxnCustom"
            />

            <PaymentMethodSelector
              title={TEXT?.SELECT_PAYMENT_METHOD}
              slideAnimation={props?.slideAnimation}
              previewMode={false}
              methods={[
                {
                  key: "neft",
                  label: TEXT?.NEFT,
                  subText: TEXT?.NEFT_TRANSFER_NOTE,
                  active: props?.isNeft,
                  notes: [
                    TEXT?.TRANSACTION_EXECUTION_NOTE,
                    TEXT?.TRANSACTION_LIMIT_NOTE,
                    TEXT?.TRANSACTION_CHARGES_NOTE,
                  ],
                  onClick: () => {
                    if (!props?.isNeft) props?.setSlideAnimation(true);
                    setTimeout(
                      () => props?.setSlideAnimation(false),
                      AnimConfig.slideDuration,
                    );
                    props?.setIsNeft(true);
                    props?.setIsImps(false);
                    props?.setIsRtgs(false);
                    props?.setTxnPayLoad({
                      ...props?.txnPayLoad,
                      settleType: "neft",
                    });
                    props?.setNextButtonEnabled(false);
                  },
                },
                {
                  key: "rtgs",
                  label: TEXT?.RTGS,
                  subText: TEXT?.INSTANT_TRANSFER_NOTE,
                  active: props?.isRtgs,
                  notes: [
                    TEXT?.RTGS_TRANSACTION_EXECUTION_NOTE,
                    TEXT?.RTGS_TRANSACTION_LIMIT_NOTE,
                    TEXT?.TRANSACTION_CHARGES_NOTE,
                  ],
                  onClick: () => {
                    if (!props?.isRtgs) props?.setSlideAnimation(true);
                    setTimeout(
                      () => props?.setSlideAnimation(false),
                      AnimConfig.slideDuration,
                    );
                    props?.setIsNeft(false);
                    props?.setIsImps(false);
                    props?.setIsRtgs(true);
                    props?.setTxnPayLoad({
                      ...props?.txnPayLoad,
                      settleType: "rtgs",
                    });
                  },
                },
              ]}
            />
          </CommonLayout>
        </div>
      )}
    </>
  );
};

export default InternalTxnAmount;
